import type { SVGProps } from 'react';
const SvgStop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#stop_svg__a)">
      <path fill="currentColor" d="M6 6h12v12H6V6Z" />
    </g>
    <defs>
      <clipPath id="stop_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgStop;
